import React, { useState, useEffect } from "react";
import SideBar from "../components/SideBar";
import TopBar from "../components/TopBar";
import wa from "../assets/image/wa-svg.svg";
import fb from "../assets/image/fb-svg.svg";
import x from "../assets/image/x-svg.svg";
import li from "../assets/image/li-svg.svg";
import ig from "../assets/image/ig-svg.svg";

function Profile() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [imageError, setImageError] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  const getInitials = (name) => {
    if (!name) return "A";
    const parts = name.trim().split(" ");
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
  };

  const getAvatarUrl = (avatar) => {
    if (!avatar) return null;

    if (avatar.startsWith("https://rccgbournemouth.org/storage/")) {
      return avatar;
    }
    return `https://rccgbournemouth.org/storage/${avatar}`;
  };

  useEffect(() => {
    const fetchProfile = async () => {
      setLoading(true);
      setError("");
      try {
        const token = localStorage.getItem("authToken");
       const TEST_BASE_URL = process.env.REACT_APP_BASE_URL;
        const res = await fetch(
          `${TEST_BASE_URL}/user-profile`,
          {
            headers: {
              "Content-Type": "application/json",
              ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
          }
        ); 

        if (!res.ok) throw new Error("Failed to fetch profile");

        const data = await res.json();

        setProfile(data.data);
      } catch (err) {
        console.error(" Error fetching profile:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  if (loading) return <p>Loading profile...</p>;
  if (error) return <p className="text-danger">{error}</p>;
  if (!profile) return <p>No profile data available.</p>;

  const avatarUrl = getAvatarUrl(profile.avatar);

  return (
    <section className="dashboard">
      <SideBar isOpen={sidebarOpen} />
      <div className="body-content">
        <TopBar onToggleSidebar={toggleSidebar} />
        <div className="profile">
          <div className="profilebg">
            <p>My Profile</p>

            <div className="avatar-img">
              {avatarUrl && !imageError ? (
                <img
                  src={avatarUrl}
                  alt={profile.name}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                  onError={() => setImageError(true)}
                />
              ) : (
                getInitials(profile.name)
              )}
            </div>
          </div>

          <div className="profile-content">
            <div className="name-edit">
              <div>
                <h6>{profile.name}</h6>
                <span>
                  <small>{profile.profession}</small>
                </span>
                <p>
                  <small>{profile.location}</small>
                </p>
              </div>
              <a href="settings?section=profile">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="17"
                  viewBox="0 0 23 22"
                  fill="none"
                >
                  <path
                    d="M13.5737 2.88545C14.3189 2.07808 14.6915 1.6744 15.0874 1.43893C16.0427 0.870759 17.2191 0.853091 18.1904 1.39232C18.5929 1.6158 18.9769 2.00812 19.745 2.79276C20.5131 3.5774 20.8972 3.96972 21.1159 4.38093C21.6438 5.37312 21.6265 6.57479 21.0703 7.5507C20.8398 7.95516 20.4446 8.33578 19.6543 9.09701L10.2506 18.1543C8.75288 19.5969 8.004 20.3182 7.06806 20.6837C6.13212 21.0493 5.1032 21.0224 3.04536 20.9686L2.76538 20.9613C2.13891 20.9449 1.82567 20.9367 1.64359 20.73C1.4615 20.5234 1.48636 20.2043 1.53608 19.5662L1.56308 19.2197C1.70301 17.4235 1.77297 16.5255 2.12371 15.7182C2.47444 14.9109 3.07944 14.2555 4.28943 12.9445L13.5737 2.88545Z"
                    stroke="#141B34"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.5 3L19.5 10"
                    stroke="#141B34"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M13.5 21L21.5 21"
                    stroke="#141B34"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>{" "}
                Edit
              </a>
            </div>

            <hr className="hr" />

            <div>
              <div className="name-edit">
                <h6>Personal Information</h6>
                <a href="settings?section=profile">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="17"
                    viewBox="0 0 23 22"
                    fill="none"
                  >
                    <path
                      d="M13.5737 2.88545C14.3189 2.07808 14.6915 1.6744 15.0874 1.43893C16.0427 0.870759 17.2191 0.853091 18.1904 1.39232C18.5929 1.6158 18.9769 2.00812 19.745 2.79276C20.5131 3.5774 20.8972 3.96972 21.1159 4.38093C21.6438 5.37312 21.6265 6.57479 21.0703 7.5507C20.8398 7.95516 20.4446 8.33578 19.6543 9.09701L10.2506 18.1543C8.75288 19.5969 8.004 20.3182 7.06806 20.6837C6.13212 21.0493 5.1032 21.0224 3.04536 20.9686L2.76538 20.9613C2.13891 20.9449 1.82567 20.9367 1.64359 20.73C1.4615 20.5234 1.48636 20.2043 1.53608 19.5662L1.56308 19.2197C1.70301 17.4235 1.77297 16.5255 2.12371 15.7182C2.47444 14.9109 3.07944 14.2555 4.28943 12.9445L13.5737 2.88545Z"
                      stroke="#141B34"
                      stroke-width="1.5"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.5 3L19.5 10"
                      stroke="#141B34"
                      stroke-width="1.5"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13.5 21L21.5 21"
                      stroke="#141B34"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>{" "}
                  Edit
                </a>
              </div>
              <div className="row editrow">
                <div className="col-md-3">
                  <div>
                    <h6>Full Name</h6>
                    <p>{profile.name}</p>
                  </div>
                  <div>
                    <h6>Email Address</h6>
                    <p>{profile.email}</p>
                  </div>
                  <div>
                    <h6>Phone Number</h6>
                    <p>{profile.phone_number || "Not set"}</p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div>
                    <h6>Bio</h6>
                    <p>{profile.bio || "Not set"}</p>
                  </div>
                </div>
                <div className="col-md-5">
                  <h6>Short Testimony</h6>
                  <p>{profile.short_testimony || "Not set"}</p>
                </div>
              </div>
            </div>

            <hr className="hr" />

            <div>
              <div className="name-edit">
                <h6>My Social Media Links</h6>
                <a href="settings?section=profile">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="17"
                    viewBox="0 0 23 22"
                    fill="none"
                  >
                    <path
                      d="M13.5737 2.88545C14.3189 2.07808 14.6915 1.6744 15.0874 1.43893C16.0427 0.870759 17.2191 0.853091 18.1904 1.39232C18.5929 1.6158 18.9769 2.00812 19.745 2.79276C20.5131 3.5774 20.8972 3.96972 21.1159 4.38093C21.6438 5.37312 21.6265 6.57479 21.0703 7.5507C20.8398 7.95516 20.4446 8.33578 19.6543 9.09701L10.2506 18.1543C8.75288 19.5969 8.004 20.3182 7.06806 20.6837C6.13212 21.0493 5.1032 21.0224 3.04536 20.9686L2.76538 20.9613C2.13891 20.9449 1.82567 20.9367 1.64359 20.73C1.4615 20.5234 1.48636 20.2043 1.53608 19.5662L1.56308 19.2197C1.70301 17.4235 1.77297 16.5255 2.12371 15.7182C2.47444 14.9109 3.07944 14.2555 4.28943 12.9445L13.5737 2.88545Z"
                      stroke="#141B34"
                      stroke-width="1.5"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.5 3L19.5 10"
                      stroke="#141B34"
                      stroke-width="1.5"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13.5 21L21.5 21"
                      stroke="#141B34"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>{" "}
                  Edit
                </a>
              </div>
              <div className="social-row mt-4">
                {profile.whatsapp_url ? (
                  <a href={profile.whatsapp_url} className="whatsapp">
                    <img src={wa} alt="" />
                    Connect on WhatsApp
                  </a>
                ) : (
                  <p className="text-secondary">No WhatsApp connected</p>
                )}

                {profile.instagram_url ? (
                  <a href={profile.instagram_url} className="instagram">
                    <img src={ig} alt="" />
                    Connect on Instagram
                  </a>
                ) : (
                  <p className="text-secondary">No Instagram connected</p>
                )}

                {profile.facebook_url ? (
                  <a href={profile.facebook_url} className="facebook">
                    <img src={fb} alt="" />
                    Connect on Facebook
                  </a>
                ) : (
                  <p className="text-secondary">No Facebook connected</p>
                )}
              </div>

              <div className="social-row mt-3">
                {profile.x_url ? (
                  <a href={profile.x_url} className="twitter">
                    <img src={x} alt="" />
                    Connect on X (Twitter)
                  </a>
                ) : (
                  <p className="text-secondary">No X (Twitter) connected</p>
                )}

                {profile.linkedin_url ? (
                  <a href={profile.linkedin_url} className="linkedin">
                    <img src={li} alt="" />
                    Connect on LinkedIn
                  </a>
                ) : (
                  <p className="text-secondary">No LinkedIn connected</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Profile;
